import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import DynamicDropdown from '../../DynamicSelector';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";
import * as Common from './../../Common';
import Dialog from './../../Dialog';

const Rep_commission = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const processStatus = sessionStorage.getItem('process');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [GenerateType, setGenerateType] = useState("V");
    const [vtmFromDate, setVtmFromDate] = useState(new Date());
    const [vtmToDate, setVtmToDate] = useState(new Date());
    const [filterLocationType, setFilterLocationType] = useState("O");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [hdrSrno, setHdrSrno] = useState("");
    const [filtercurrency, setFilterCurrency] = useState(true);
    const [filterVtm, setFilterVtm] = useState(true);
    const [filterEvtm, setFilterEvtm] = useState(true);
    const [filterDD, setFilterDD] = useState(true);
    const [filterTT, setFilterTT] = useState(true);
    const [nParty, setNParty] = useState(null);
    const [nAgent, setNAgent] = useState(null);
    const [nExecutive, setNExecutive] = useState(null);
    const [filterParty, setFilterParty] = useState("A");
    const [filterAgent, setFilterAgent] = useState("A");
    const [filterExecutive, setFilterExecutive] = useState("A");
    const [selectedItems3, setSelectedItems3] = useState([]);
    const [radioType3, setRadioType3] = useState('A');
    const [reportType, setReportType] = useState("D");
    const [filterOTH, setFilterOTH] = useState(true);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_COMMISSION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleGenerate = () => {
        $(".loader").show();

        if (!Common.validateFinYear(Common.dateYMD(vtmFromDate), Common.dateYMD(vtmToDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (vtmFromDate > vtmToDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if ((filterLocationType === 'O' && filterLocation === null) || ((!filtercurrency) && (!filterDD) && (!filterEvtm) && (!filterTT) && (!filterVtm)) ||
            (filterParty === 'O' && nParty === null) || (filterAgent === 'O' && nAgent === null) || (filterExecutive === 'O' && nExecutive === null) || (radioType3 == 'S' && selectedItems3.length < 1)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (filterLocationType === 'O' && filterLocation === null ? "Select Location" : '')
            msg[i++] = (((!filtercurrency) && (!filterDD) && (!filterEvtm) && (!filterTT) && (!filterVtm)) ? "Please check atleast one checkbox  ." : '');
            msg[i++] = (((filterParty === 'O' && nParty === null)) ? "Please select party." : '');
            msg[i++] = (((filterAgent === 'O' && nAgent === null)) ? "Please select Agent." : '');
            msg[i++] = ((filterExecutive === 'O' && nExecutive === null) ? "Please select executive." : '');
            msg[i++] = ((radioType3 == 'S' && selectedItems3.length < 1) ? "Please select atleast one Transaction." : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                fromDate: Common.dateYMD(vtmFromDate),
                fromDateDMY: Common.dateDMY(vtmFromDate),
                toDate: Common.dateYMD(vtmToDate),
                toDateDMY: Common.dateDMY(vtmToDate),
                generateType: GenerateType,
                locationCode: locationCode,
                filterLocationType: filterLocationType,
                locationType: filterLocationType,
                filterCN: filtercurrency,
                filterDD: filterDD,
                filterEvtm: filterEvtm,
                filterTT: filterTT,
                filterVtm: filterVtm,
                filterOTH: filterOTH,
                filterParty: filterParty,
                nParty: nParty,
                nExecutive: nExecutive,
                filterAgent: filterAgent,
                nAgent: nAgent,
                filterExecutive: filterExecutive,
                radioTypeTransaction: radioType3,
                multipleTransaction: selectedItems3,
                reportType: reportType,
            };
            if (GenerateType === 'D') {
                Common.callDownloadApiPost1(Common.apiCommissionreport, "post", [sid, "download", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiCommissionreport, [sid, "view", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }

    const handleLocationType = (e) => {
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }
    const handlePartyChange = (value) => {
        setNParty(value);
        console.log("this is party", value)
        var id = value.id;
        var location = id.split("^");
    }
    const handleAgentChange = (value) => {
        setNAgent(value);
    }
    const handleExecutiveChange = (value) => {
        setNExecutive(value);
    }
    const handleDataFromChild = (type, newSelectedItems, newRadioType) => {
        setSelectedItems3(newSelectedItems);
        setRadioType3(newRadioType);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Commission Report </h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterLocationType} onChange={handleLocationType}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterLocationType === 'O' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={filterLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeLocation}
                                    isDisabled={branchDisable === "true"}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col></> : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> From Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={vtmFromDate}
                                onChange={(date) => setVtmFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> To Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={vtmToDate}
                                onChange={(date) => setVtmToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Party Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterParty} onChange={(e) => setFilterParty(e.target.value)}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterParty === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Party<span className='colorThemeRed'>*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={nParty}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE  , DEALER , ISSUER', locationCode)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handlePartyChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Executive Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterExecutive} onChange={(e) => setFilterExecutive(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterExecutive === 'O' ?
                        < Col className="col-md-3 col-6">
                            <Form.Group>
                                <Form.Label>Executive</Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={nExecutive}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchExecutivePicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleExecutiveChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Agent Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterAgent} onChange={(e) => setFilterAgent(e.target.value)}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterAgent === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Agent<span className='colorThemeRed'>*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={nAgent}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', locationCode)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleAgentChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                </Row>
                <Row>
                    {/* <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Report Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={reportType} onChange={e => setReportType(e.target.value)}
                                required>
                                <option value="D">Product Wise</option>
                            </Form.Select>
                        </Form.Group>
                    </Col> */}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={GenerateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="Currency "
                            checked={filtercurrency}
                            onChange={() => setFilterCurrency(!filtercurrency)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="VTM "
                            checked={filterVtm}
                            onChange={() => setFilterVtm(!filterVtm)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="EVTM "
                            checked={filterEvtm}
                            onChange={() => setFilterEvtm(!filterEvtm)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="DD "
                            checked={filterDD}
                            onChange={() => setFilterDD(!filterDD)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="TT"
                            checked={filterTT}
                            onChange={() => setFilterTT(!filterTT)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="OTH"
                            checked={filterOTH}
                            onChange={() => setFilterOTH(!filterTT)}
                        />
                    </Col>
                </Row >
                <Row>
                    <Col>
                        <Form.Label>Transaction Filter</Form.Label><br />

                        <DynamicDropdown type='transaction' onDataFromChild={handleDataFromChild} />
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

            </Container >
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_commission;